<template>
  <div>
    <navbar></navbar>
    <container class="mt-3 d-flex">
      <form @submit.prevent="login" class="mx-auto">
        <div class="card shadow-sm">
          <div class="card-body">
            <div
              v-if="error"
              class="mb-3 alert alert-warning"
              v-text="error"
            ></div>
            <div class="mb-3">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                v-model="email"
                class="form-control"
                autocomplete="username"
              />
            </div>
            <div class="mb-3">
              <label for="password">Password</label>
              <input
                type="password"
                id="password"
                v-model="password"
                class="form-control"
                autocomplete="current-password"
              />
            </div>
          </div>
          <div class="card-footer text-end">
            <button type="submit" class="btn btn-primary">Login</button>
          </div>
        </div>
      </form>
    </container>
  </div>
</template>
<script>
export default {
  name: "AdminLogin",
  data: () => ({
    email: "",
    password: "",
    error: false
  }),
  methods: {
    async login() {
      const { data } = await this.axios.post("/api/users/login.json", {
        email: this.email,
        password: this.password
      });

      if (typeof data == "string") {
        this.error = data;
        return;
      }
      await this.$store.dispatch("login", data);
      this.$router.push("/admin/users");
    }
  }
};
</script>
